import { Policy } from "@models/Policy.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class PolicySerializer extends BaseSerializer {
  public deserialize(data: any): Policy {
    const gp = new Policy();
    this._copyLayersAttributes(gp, data);
    return gp;
  }
}
